import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Section from '@/components/base/Section'
import Typography from '@/components/base/Typography'

import { cardGridRevealAnimation } from './animations'
import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

export type CardGridProps = HTMLAttributes<HTMLDivElement> & {
  title: string
  subtitle: string
  cards: {
    card_clone: {
      icon: WPImage
      overline: string
      title: string
      text: string
    }
  }[]
}

const CardGrid = ({ title, subtitle, cards, ...props }: CardGridProps) => {
  return (
    <Motion animation={cardGridRevealAnimation}>
      <Section {...props}>
        <Container>
          <Grid>
            <div
              className={cn(
                'col-span-4 flex flex-col gap-spacing-sm pb-spacing-md md:col-span-6 lg:col-span-4'
              )}
              data-motion-heading
            >
              <Typography variant="h5">{title}</Typography>
              <Typography variant="large" className="font-medium text-text-accent-light-dark">
                {subtitle}
              </Typography>
            </div>
            <div
              className={cn(
                'col-span-4 md:col-span-6 lg:col-span-8 lg:ml-0',
                'grid grid-cols-1 gap-spacing-sm md:grid-cols-2 md:gap-[var(--gutter)] lg:grid-cols-2'
              )}
            >
              {cards.map((card, index) => (
                <div
                  key={index}
                  className="flex h-full flex-col rounded-[8px] bg-gradient-to-b from-[#545454] to-[#303030] p-[1px]"
                  data-motion-card
                >
                  <div className="flex flex-grow flex-col gap-spacing-sm rounded-[8px] bg-[#111111] p-spacing-sm">
                    <Typography variant="large" className="font-medium text-text-accent-dark">
                      {card.card_clone.title}
                    </Typography>
                    <Typography variant="regular" className="text-text-secondary-invert-dark">
                      {card.card_clone.text}
                    </Typography>
                  </div>
                </div>
              ))}
            </div>
          </Grid>
        </Container>
      </Section>
    </Motion>
  )
}

export default CardGrid
